import { AxiosMethod } from "../entities/Environment";
import request from "../axios/axios";
import { SearchReqInterface } from "../entities/Search";
import { CustomAsyncSelectResponse } from "../entities/CustomSelect";
import { CommonResponseInterface } from "../entities/Common";

export enum SearchEndpoints {
  SEARCH_PUBLIC = "post/search-public",
}

export class SearchService {
  static searchAll(
    query: SearchReqInterface,
  ): Promise<CommonResponseInterface<CustomAsyncSelectResponse>> {
    return request({
      url: `${SearchEndpoints.SEARCH_PUBLIC}?limit=${query.limit}&offset=${query.offset}&type=${query.type}&textFilter=${query.textFilter}`,
      method: AxiosMethod.GET,
    });
  }
}
